"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useProductsFromCollection", {
  enumerable: true,
  get: function get() {
    return _useProductsFromCollection["default"];
  }
});
Object.defineProperty(exports, "fetcher", {
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
});
exports["default"] = void 0;
var _useProductsFromCollection = _interopRequireDefault(require("./useProductsFromCollection"));
var _fetcher = _interopRequireDefault(require("./fetcher"));
var _default = _useProductsFromCollection["default"];
exports["default"] = _default;